"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TreeNode", {
  enumerable: true,
  get: function get() {
    return _TreeNode.default;
  }
});
exports.default = void 0;
var _Tree = _interopRequireDefault(require("./Tree"));
var _TreeNode = _interopRequireDefault(require("./TreeNode"));
var _default = _Tree.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree/lib/index.js
// module id = 1186
// module chunks = 0